import React, { useEffect } from 'react';

const SMLModal = ({id, className = '', size = 'md', title = null, children, onShown}) => {
  useEffect(() => {
    if (onShown) {
      $(`.modal#${id}`).on('show.bs.modal', onShown);
    }
  }, []);

  return (
    <div className={`modal fade ${className}`} id={id}>
      <div className={`modal-dialog modal-${size}`} role="document">
        <div className="modal-content">
          {title && 
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{marginTop: '7px'}}>
                <span aria-hidden="true">&times;</span>
              </button>
              <h3 className="modal-title">{title}</h3>
            </div>
          }
          <div className="modal-body">
            {!title &&
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            }
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SMLModal;
